import Image1 from './1-min.jpg'
import Image2 from './2-min.jpg'
import Image3 from './3-min.jpg'
import Image4 from './4-min.jpg'
import Image5 from './5-min.jpg'
import Image6 from './6-min.jpg'
import Image7 from './7-min.jpg'
import Image8 from './8-min.jpg'
import Image10 from './10-min.jpg'
import Image11 from './11-min.jpg'
import Image12 from './12-min.jpg'
import Image13 from './13-min.jpg'
import Image14 from './14-min.jpg'
import Image15 from './15-min.jpg'
import Image16 from './16-min.jpg'
import Image18 from './18-min.jpg'
import Image19 from './19-min.jpg'
import Image20 from './20-min.jpg'
import Image22 from './22-min.jpg'
import Image23 from './23-min.jpg'
import Image25 from './25-min.jpg'
import Image26 from './26-min.jpg'
import Image27 from './27-min.jpg'
import Image28 from './28-min.jpg'
import Image29 from './29-min.jpg'
import Image31 from './31-min.jpg'
import Image32 from './32-min.jpg'
import Image33 from './33-min.jpg'
import Image34 from './34-min.jpg'
import Image35 from './35-min.jpg'
import Image36 from './36-min.jpg'
import Image37 from './37-min.jpg'
import Image38 from './38-min.jpg'
import Image39 from './39-min.jpg'
import Image41 from './41-min.jpg'
import Image42 from './42-min.jpg'
import Image43 from './43-min.jpg'
import Image44 from './44-min.jpg'
import Image45 from './45-min.jpg'
import Image46 from './46-min.jpg'
import Image47 from './47-min.jpg'
import Image48 from './48-min.jpg'
import Image49 from './49-min.jpg'
import Image50 from './50-min.jpg'
import Image51 from './51-min.jpg'
import Image52 from './52-min.jpg'
import Image53 from './53-min.jpg'
import Image54 from './54-min.jpg'
import Image55 from './55-min.jpg'
import Image56 from './56-min.jpg'
import Image57 from './57-min.jpg'
import Image58 from './58-min.jpg'
import Image59 from './59-min.jpg'
import Image60 from './60-min.jpg'
import Image61 from './61-min.jpg'
import Image62 from './62-min.jpg'
import Image63 from './63-min.jpg'
import Image64 from './64-min.jpg'
import Image65 from './65-min.jpg'
import Image66 from './66-min.jpg'
import Image67 from './67-min.jpg'
import Image68 from './68-min.jpg'
import Image69 from './69-min.jpg'
import Image70 from './70-min.jpg'
import Image71 from './71-min.jpg'
import Image72 from './72-min.jpg'
import Image73 from './73-min.jpg'

export default [
  Image1,
  Image2,
  Image3,
  Image4,
  Image5,
  Image6,
  Image7,
  Image8,
  Image10,
  Image11,
  Image12,
  Image13,
  Image14,
  Image15,
  Image16,
  Image18,
  Image19,
  Image20,
  Image22,
  Image23,
  Image25,
  Image26,
  Image27,
  Image28,
  Image29,
  Image31,
  Image32,
  Image33,
  Image34,
  Image35,
  Image36,
  Image37,
  Image38,
  Image39,
  Image41,
  Image42,
  Image43,
  Image44,
  Image45,
  Image46,
  Image47,
  Image48,
  Image49,
  Image50,
  Image51,
  Image52,
  Image53,
  Image54,
  Image55,
  Image56,
  Image57,
  Image58,
  Image59,
  Image60,
  Image61,
  Image62,
  Image63,
  Image64,
  Image65,
  Image66,
  Image67,
  Image68,
  Image69,
  Image70,
  Image71,
  Image72,
  Image73,
]
